module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Delete recording?","origin":"Origin"},"es":{"dialogTitle":"¿Eliminar grabación?","origin":"Origen"}}')
  delete Component.options._Ctor
}
